import * as R from 'ramda';
import * as React from 'react';
import { css } from '@emotion/core';
import { FLEX_ROW } from './flexBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { CHART_COLORS, COLORS } from '../globalStyle/colors';
import LocalDiv from '../localization/LocalDiv';


const styles = {
  root:         css`
    font-size: 18px;
    color: ${CHART_COLORS.PERSON};
    
    &[dir="ltr"] > * {
      margin-right: 5px;
    }
  
    &[dir="rtl"] > * {
      margin-left: 5px;
    }
  `,
  active:       css`
    color: ${COLORS.DARK_GREY};
  `,
  iconOverflow: css`
    font-weight: bold;
  `,
};


type Props = {
  numberOfIcons: number;
  iconMax?: number;
  numberOfActive?: number;
  icon?: IconDefinition;
  className?: string;
};


/**
 * PeopleCounter: a component that renders a row of people icons (or any icons really). Use className to set `color` and
 * `font-size` (These are font awesome icons). Default is a person icon with grey color.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const IconRow: React.FC<Props> = props => (
  <LocalDiv css={[FLEX_ROW, styles.root]} className={props.className}>
    {
      R.range(0, Math.min(props.iconMax!, props.numberOfIcons))
        .map(i => (
          <FontAwesomeIcon
            key={i}
            icon={props.icon!}
            css={i < props.numberOfActive! ? styles.active : ''}
          />
        ))
    }
    {
      props.numberOfIcons > props.iconMax! && <span css={styles.iconOverflow}>+</span>
    }
    {
      props.numberOfIcons > props.iconMax! && (
        <span css={styles.iconOverflow}>{props.numberOfIcons - props.iconMax!}</span>
      )
    }
  </LocalDiv>
);

IconRow.defaultProps = {
  icon:           faUser,
  iconMax:        Number.MAX_VALUE,
  numberOfActive: 0,
};

export default IconRow;
